import * as React from "react";

const SvgIcnNotificationDegraded = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.233 8.375H8.543c-.645 0-1.167.522-1.167 1.167v7.041c0 .645.522 1.167 1.167 1.167h4.927v.781h-1.813a.625.625 0 000 1.25h4.875a.625.625 0 100-1.25H14.72v-.781h4.927c.644 0 1.166-.522 1.166-1.167v-2.95c-.395.17-.834.21-1.25.12V16.5H8.625V9.625h6.347l-.17-.17a2.049 2.049 0 01-.569-1.08zm1.045 1.557a.832.832 0 00-.409.387l-1.8 3.6-.967-1.452a.828.828 0 00-.689-.368h-1.01a.625.625 0 000 1.25h.784l1.246 1.868a.827.827 0 001.43-.088l1.799-3.6.968 1.452a.829.829 0 00.688.368h.397a.625.625 0 00.582-.398l-3.019-3.02z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.49 7.252L20.747 3.51a1.058 1.058 0 00-1.497 0l-3.742 3.742a1.058 1.058 0 000 1.496l3.742 3.742a1.058 1.058 0 001.497 0l3.741-3.742a1.058 1.058 0 000-1.496zM20.004 6.2h-.013c-.362 0-.643.355-.586.746l.256 1.343c.025.178.167.311.334.311H20c.167 0 .31-.133.334-.311l.257-1.343c.057-.39-.22-.742-.587-.746zm.593 3.6a.6.6 0 11-1.2 0 .6.6 0 011.2 0z"
            fill="#AD1111"
        />
    </svg>
);

export default SvgIcnNotificationDegraded;
